"use strict";

(function () {
      document.addEventListener("DOMContentLoaded", function () {
            const form = document.getElementById('shopSort');
            // チェックボックスをすべて取得
            const checkboxes = document.querySelectorAll('.shop-sort-list__item input[type="checkbox"]');

            // モーダルのチェックボックスリストからタグの表示
            form.addEventListener('submit', function (e) {
                  // フォームの送信をキャンセル
                  e.preventDefault();

                  // 既存のクラスを一度リセット
                  document.querySelectorAll('.sale-shop-sort-check-list__item.is-show').forEach(function (el) {
                        el.classList.remove('is-show');
                  });

                  // チェックされているものだけクラスを追加
                  checkboxes.forEach(function (checkbox) {
                        if (checkbox.checked) {
                              // 対応する要素を取得
                              const tagElement = document.getElementById(checkbox.value);
                              if (tagElement) {
                                    // クラスを追加
                                    tagElement.classList.add('is-show');
                              }
                        }
                  });

                  // 店舗リストの絞り込み
                  sale_shop_list(form);

                  // モーダルのクローズボタンを押す
                  document.querySelector('.close-btn').click();
            });

            // 表示されたタグの削除
            document.querySelectorAll('.sale-shop-sort-check-list__item').forEach(function (element) {
                  element.addEventListener('click', function (e) {
                        e.preventDefault();
                        // タグの削除
                        e.currentTarget.classList.remove("is-show");

                        // クリックされた要素のIDを取得
                        const elementId = this.id;

                        // 対応するチェックボックスを取得
                        const checkbox = document.querySelector(`.shop-sort-list__item input[type="checkbox"][value="${elementId}"]`);
                        if (checkbox) {
                              // チェックを外す
                              checkbox.checked = false;
                        }

                        sale_shop_list(form);
                  });
            });

            function sale_shop_list(form) {
                  const shoplist = document.querySelectorAll('.sale-shop__item');

                  // すべてのアイテムを非表示にする
                  shoplist.forEach(item => item.classList.remove('is-show'));

                  // 選択されたビル名とカテゴリを取得
                  const selectedBuildings = Array.from(form.querySelectorAll('.building[type="checkbox"]:checked'))
                        .map(checkbox => checkbox.value);

                  const selectedCategories = Array.from(form.querySelectorAll('.subcat[type="checkbox"]:checked'))
                        .map(checkbox => checkbox.value);

                  // 両方とも空の場合、すべてのアイテムを表示
                  if (selectedBuildings.length === 0 && selectedCategories.length === 0) {
                        shoplist.forEach(item => {
                              setTimeout(() => {
                                    item.classList.add('is-show');
                              }, 100); // 遅延
                        });
                        shot_not_list(shoplist, shop_not_list);
                        return; // 絞り込み終了
                  }

                  // ビル名のみで絞り込み
                  const filteredByBuilding = Array.from(shoplist).filter(item => {
                        const itemClasses = Array.from(item.classList).filter(cls => cls !== 'sale-shop__item');
                        return selectedBuildings.some(building => itemClasses.includes(building));
                  });

                  // カテゴリのみで絞り込み
                  const filteredByCategories = Array.from(shoplist).filter(item => {
                        const itemClasses = Array.from(item.classList).filter(cls => cls !== 'sale-shop__item');
                        return selectedCategories.some(category => itemClasses.includes(category));
                  });

                  // カテゴリ未選択の場合、ビル名だけで表示
                  if (selectedCategories.length === 0) {
                        filteredByBuilding.forEach(item => {
                              setTimeout(() => {
                                    item.classList.add('is-show');
                              }, 100); // 遅延
                        });
                        shot_not_list(shoplist,300);
                        return; // 絞り込み終了
                  }

                  //ビル名未選択の場合、カテゴリだけで表示
                  if (selectedBuildings.length === 0) {
                        filteredByCategories.forEach(item => {
                              setTimeout(() => {
                                    item.classList.add('is-show');
                              }, 100); // 遅延
                        });
                        shot_not_list(shoplist,300);
                        return; // 絞り込み終了
                  }

                  // ビル名 & カテゴリ名の組み合わせでさらに絞り込み
                  filteredByBuilding.forEach(item => {
                        const itemClasses = Array.from(item.classList).filter(cls => cls !== 'sale-shop__item');

                        const matchesCombination = selectedBuildings.some(building =>
                              selectedCategories.some(category =>
                                    itemClasses.includes(building) && itemClasses.includes(category)
                              )
                        );

                        // 組み合わせ条件を満たす場合にis-showを追加
                        if (matchesCombination) {
                              setTimeout(() => {
                                    item.classList.add('is-show');
                              }, 100); // 遅延
                        }
                  });

                  shot_not_list(shoplist,300);
            }

            function shot_not_list(shoplist,delay) {
                  const shop_not_list = document.querySelector('.sale-shop-not-list');
                  shop_not_list.classList.remove('is-show');
                  setTimeout(() => {
                        // is-showクラスがあるかどうかをチェック
                        const hasIsShowClass = Array.from(shoplist).some(li => li.classList.contains('is-show'));
                        // is-showクラスがない場合、指定の要素に追加
                        if (!hasIsShowClass) {
                              shop_not_list.classList.add('is-show');
                        }
                  }, delay); // 遅延
            }
      });
})();

